import React from "react";
import { motion } from "framer-motion";
import {
  Building,
  ShoppingBag,
  UtensilsCrossed,
  Hotel,
  Home,
  Stethoscope,
  GraduationCap,
  Warehouse,
} from "lucide-react";

const SECTORS = [
  { label: "Bureaux & entreprises", Icon: Building },
  { label: "Commerces & boutiques", Icon: ShoppingBag },
  { label: "Restaurants & CHR", Icon: UtensilsCrossed },
  { label: "Hôtels & résidences", Icon: Hotel },
  { label: "Copropriétés", Icon: Home },
  { label: "Cabinets médicaux", Icon: Stethoscope },
  { label: "Établissements scolaires", Icon: GraduationCap },
  { label: "Entrepôts & industrie", Icon: Warehouse },
];

export default function Sectors() {
  return (
    <section id="secteurs" className="relative py-24 md:py-32 bg-[#F8FAFC]" data-testid="sectors-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-5">
            <div className="text-xs uppercase tracking-[0.3em] text-[#2E9E6E] font-medium mb-4">
              — Secteurs d'intervention
            </div>
            <h2 className="font-display font-semibold text-4xl md:text-5xl text-[#0F2B5B] leading-[1.02] tracking-tight">
              Des prestations pensées pour votre secteur d'activité.
            </h2>
          </div>
          <div className="md:col-span-7 md:col-start-7 text-slate-600 leading-relaxed flex items-end">
            <p>
              Chaque environnement a ses propres contraintes : horaires
              d'ouverture, normes d'hygiène, flux de public, sensibilité des
              surfaces. Nos équipes s'adaptent pour garantir un résultat
              constant et sans perturbation de votre activité.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 border-t border-l border-slate-200">
          {SECTORS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="group relative border-r border-b border-slate-200 p-6 md:p-8 bg-white hover:bg-[#0F2B5B] transition-colors duration-300 cursor-default"
              data-testid={`sector-${i}`}
            >
              <s.Icon
                className="w-7 h-7 text-[#0F2B5B] group-hover:text-[#2E9E6E] transition-colors"
                strokeWidth={1.5}
              />
              <div className="mt-8 font-display text-lg md:text-xl font-medium text-[#0F2B5B] group-hover:text-white transition-colors leading-tight">
                {s.label}
              </div>
              <div className="mt-2 text-xs text-slate-400 group-hover:text-[#2E9E6E] transition-colors uppercase tracking-wider">
                0{i + 1}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
